<template>
  <table v-if="!isLoading" class="table table-detail">
    <tbody>
      <tr
        v-for="(item, index) in items"
        :key="`row-detail-table-detail-${index}`"
      >
        <!-- label -->
        <td
          :class="{
            'nowrap-table': !item.wrapLabel,
          }"
        >
          {{ item.label }}
        </td>
        <!-- separator -->
        <td v-if="!hideSeparator" class="nowrap-table">
          <slot name="separator"> : </slot>
        </td>
        <!-- value -->
        <td>
          <span :class="item.value_class">
            {{ item.value | parse(item.transform) }}
          </span>
          <br v-if="item.sub_value" />
          <div v-if="item.sub_value" :class="item.sub_value_class">
            {{ item.sub_value }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "GrowerWebTableDetail",

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    hideSeparator: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style scoped>
.table-detail tr:first-child td {
  border-top: none !important;
}
.img-table {
  height: 150px;
  width: 150px;
  border-radius: 8px;
  object-fit: cover;
  cursor: pointer;
  margin-right: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/base/component/table-detail.vue